// extracted by mini-css-extract-plugin
export default {"container":"NF-z","disabled":"OF-z","bgBlack":"PF-z","content":"QF-z","countdown":"RF-z","topCaption":"SF-z","topHeading":"TF-z","heading":"UF-z","copy":"VF-z"};